export const ApiParams = {
  lockTypes: {
    assessment: 0,
    collectionItem: 1,
    scheduleReScoring: 2,
    markingScheme: 3,
    scheduleSharing: 4,
    reviewSharing: 5,
    scoring: 6,
  },
}
